import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

export class ButtonComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div className={css(Styles.buttonOuterContainer)}>
        {/* <Button className={css(Styles.buttonContainer,Styles.buttonContainerSecond)}>
        CLEAR
        </Button> */}
        {/* {subSectionCompleted &&
          <div>
            <p className={css(Styles.buttonInnerContent)}>You have already completed this section</p>
            <p className={css(Styles.subText)}>Your responses have been encrypted and archived for security and privacy reasons</p>
          </div>
        }

        <p className={css(CommonStyles.errMsg)}>{this.props.errMsg ? this.props.errMsg : ''}</p> */}

        <div className={css(Styles.buttonInnerContainer)}>
          <Button
            variant='contained'
            disabled={this.props.inProcess}
            className={css(Styles.buttonContainer)}
            onClick={() => (this.props.onSelect) &&  this.props.onSelect()}
            {...this.props}
          >
            {this.props.label}
            {this.props.inProcess &&
              <CircularProgress
                size={22}
                className={css(Styles.marginLeft)} />}
          </Button>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  buttonOuterContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  buttonInnerContent: {
    textAlign: 'center',
    fontSize: 22,
    margin: AppTheme.pMargin,
    marginBottom: 10
  },
  subText: {
    textAlign: 'center',
    fontSize: 14,
    margin: AppTheme.pMargin,
    marginBottom: 50
  },
  buttonInnerContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonContainer: {
    minWidth: 230,
    fontSize: 17,
    fontWeight: 'normal',
    borderRadius: 30,
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.secondaryBg,
    '@media (max-width: 767px)': {
      minWidth: 150,
      fontSize: 13,
      borderRadius: 25,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      width: 180,
    },
  },
  buttonContainerSecond: {
    color: AppTheme.tertiaryColor,
    ':hover': {
      backgroundColor: 'transparent'
    }
  },
  marginLeft: {
    marginLeft: 10,
    color: AppTheme.secondaryBg,
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/ButtonComponent.js